// import ScheduleCalendar from "./Calendar";
import ScheduleLegend from "./ScheduleLegend";

export { ScheduleLegend };
